import TranslationNS from '@/utils/Constants/TranslationNS'

const CONTRACT = TranslationNS.CONTRACT_SIGNATURE

/**
 * Contracts › « Rapports » — `contract-reports` and `staff/contract-reports`, one tour: the counts
 * (and the link back to an unfinished contract), the primary request, « Export all contracts », the
 * signatures card, its status chips and search, the table and its row actions, the pager.
 */
export const CONTRACT_REPORTS_TOUR = {
    id: 'contract-reports',
    version: 1,
    paths: ['contract-reports', 'staff/contract-reports'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="page-head"]',
            placement: 'bottom',
            title: 'Who has signed',
            description:
                'The count of signatures received and of requests sent. While the contract is not finished, a link takes you back to its settings.',
        },
        {
            key: 'request',
            target: '[data-tour="rep-request"]',
            placement: 'bottom',
            placementNarrow: 'top',
            title: 'Chase the signatures',
            description:
                'Sends an e-mail to every person who has not signed yet, once the contract is published. A summary tells who was skipped (one reminder every 3 days). Once everyone signed, a tag replaces the button.',
        },
        {
            key: 'export',
            target: '[data-tour="rep-export"]',
            placement: 'bottom',
            title: 'Download the contracts',
            description: 'Gets every signed contract in a single file.',
        },
        {
            key: 'list',
            // the card's title band, not the card: a list taller than the screen leaves no room for the bubble
            target: '[data-tour="sec-signatures"]',
            block: ':scope > .org-sec-h',
            placement: 'bottom',
            title: 'The list of registrants',
            description: 'One row per person who has to sign.',
        },
        {
            key: 'status',
            target: '[data-tour="rep-status"]',
            placement: 'bottom',
            title: 'Filter by state',
            description: 'Show only the people who signed, who were asked, or not yet.',
        },
        {
            key: 'search',
            target: '[data-tour="rep-search"]',
            placement: 'bottom',
            title: 'Search a person',
            description: 'Type a name, a team or an e-mail address. « Reset filters » clears everything.',
        },
        {
            key: 'table',
            target: '[data-tour="sec-signatures"] .org-tbl',
            block: 'thead',
            placement: 'bottom',
            title: 'Each person, one row',
            description: 'Name and team, state, date of the request, then the actions of the row.',
            entries: [
                { label: 'Resend', ns: CONTRACT, text: 'sends the request again to this person only.' },
                { label: 'PDF', ns: CONTRACT, text: 'downloads the signed contract.' },
            ],
        },
        {
            key: 'pager',
            target: '[data-tour="sec-signatures"] .org-pager',
            placement: 'top',
            title: 'Page by page',
            description: 'Choose how many rows per page and move between pages.',
        },
    ],
}

export default CONTRACT_REPORTS_TOUR
